/* eslint-disable react/no-array-index-key */
import {Interpolation, SerializedStyles, Theme} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import React from 'react';

import {ChartColor} from './LightChart';
import {TooltipWrapper} from '../TooltipWrapper';

type Props = {
  items: ChartColor[];
  hiddenMap: React.MutableRefObject<Record<string | number, boolean>>;
  onSetHiddenMap: () => void;
  legendRowStyles?: SerializedStyles | Interpolation<Theme>;
  textColor?: string;
};
export const LightChartLegend2: React.FC<Props> = (props) => {
  const {items, hiddenMap, onSetHiddenMap, legendRowStyles, textColor} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme, params: {legendRowStyles}});
  const onClick = (id: string | number, isDoubleClick: boolean) => {
    const shownCount = items.reduce((acc, v, i) => acc + (hiddenMap.current[v.id ?? i] ? 0 : 1), 0);
    if (isDoubleClick) {
      // NOTE: the two clicks already cancelled each other
      if (hiddenMap.current[id]) {
        hiddenMap.current = Object.fromEntries(items.map((v) => [v.id, true]));
        hiddenMap.current[id] = false;
      } else if (shownCount === 1) {
        hiddenMap.current = {};
      } else {
        hiddenMap.current = Object.fromEntries(items.map((v) => [v.id, true]));
        hiddenMap.current[id] = false;
      }
    } else {
      hiddenMap.current[id] = !hiddenMap.current[id];
    }
    onSetHiddenMap();
  };
  return (
    <div css={muiStyles.legendRow}>
      {items.map((v, i) => {
        const color = v.hidden ? 'var(--dlThemeGray-500)' : v.color;
        return (
          <TooltipWrapper
            key={i}
            tooltip={v.label}
            wrapperCss={muiStyles.item}
            onClick={() => onClick(v.id ?? i, false)}
            onDoubleClick={() => onClick(v.id ?? i, true)}
          >
            <div css={muiStyles.icon}>
              <div css={muiStyles.iconCircle} style={{background: color}} />
              <div css={muiStyles.iconLine} style={{background: color}} />
            </div>
            <span css={muiStyles.label} style={{color: textColor ?? color}}>
              {v.label}
            </span>
          </TooltipWrapper>
        );
      })}
    </div>
  );
};
const getStyles: GetStylesFunction = (_options) => {
  return {
    legendRow: css({
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      background: 'var(--dlThemeGray-100)',
      borderRadius: '8px',
      ...(_options?.params?.legendRowStyles ?? {}),
    }),
    item: css`
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding: 8px 8px 4px 8px;
      cursor: pointer;
      user-select: none;
    `,
    icon: css`
      position: relative;
      width: 100%;
      height: 10px;
    `,
    iconCircle: css`
      position: absolute;
      top: calc(50% - 5px);
      left: calc(50% - 5px);
      width: 10px;
      height: 10px;
      border-radius: 50%;
    `,
    iconLine: css`
      position: absolute;
      top: calc(50% - 1px);
      width: 100%;
      height: 2px;
    `,
    label: css`
      display: inline-block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      padding-right: 1px;
    `,
  };
};
